import ElTag from './src/tag';
import '@/theme/css/basic/tag.scss';

/* istanbul ignore next */
// ElTag.install = function(Vue) {
//   Vue.component(ElTag.name, ElTag);
// };

export default ElTag;